<template>

    <div>

        <h3 class="text-center main-sub-title">selected element</h3>
        <h2 class="text-center main-title">Pricing Table</h2>

        <div class="text-center">
            <div class="blocks-action-bar-inline">
                <div class="device-selector--large inline-style">

                    <i class="fas fa-desktop active" data-device="desktopSettings" v-b-tooltip.hover.top title="Desktop" @click="switchDevice"></i>
                    <i class="fas fa-tablet-alt" data-device="tabletSettings" v-b-tooltip.hover.top title="Tablet" @click="switchDevice"></i>
                    <i class="fas fa-mobile-alt" data-device="mobileSettings" v-b-tooltip.hover.top title="Phone" @click="switchDevice"></i>

                </div>
                
                <b-button v-b-tooltip.hover.top title="Add child block" variant="primary" class="addChildBlock-btn" size="sm" @click="addToChildArray">
                    +</b-button>
            </div>
        </div>

        <div class="preview-box" :style="{width : previewBoxWidth}">

            <draggable class="bundle-pricing-table-1-wrap"
                v-model="slidesArray" 
                ghost-class="ghost-block" 
                handle=".block-drag-handle"
                :id="settingsFromWeebly.settings.tableWrapperId">

                <PricingtableElement 
                    v-for="(pricingtable, index) in slidesArray" :key="index"
                    :arrayIndex="index"
                    :curTable="pricingtable"
                />

            </draggable>

            <component :is="style" v-for="(pricingtable, index) in slidesArray" :key="index">
                
                #{{pricingtable.tableId}} .bundle-pricing-table-header h4  {
                    color: {{pricingtable.colorPlan}};
                    font-family: {{pricingtable.useCustomFontPlan ? pricingtable.customFontNamePlan : pricingtable.fontFamilyPlan}};
                    font-style: {{pricingtable.useCustomFontPlan ? pricingtable.customFontStylePlan : pricingtable.fontStylePlan}};
                    font-weight: {{pricingtable.useCustomFontPlan ? pricingtable.customFontWeightPlan : pricingtable.fontWeightPlan}};
                    font-size: {{pricingtable.fontSizePlan}}px;
                    background: {{pricingtable.bgPlan}};
                }

                #{{pricingtable.tableId}} .bundle-pricing-table-header h5  {
                    color: {{pricingtable.colorPrice}};
                    font-family: {{pricingtable.useCustomFontPrice ? pricingtable.customFontNamePrice : pricingtable.fontFamilyPrice}};
                    font-style: {{pricingtable.useCustomFontPrice ? pricingtable.customFontStylePrice : pricingtable.fontStylePrice}};
                    font-weight: {{pricingtable.useCustomFontPrice ? pricingtable.customFontWeightPrice : pricingtable.fontWeightPrice}};
                    font-size: {{pricingtable.fontSizePrice}}px;
                }

                #{{pricingtable.tableId}} .bundle-pricing-table-header h5 span {
                    color: {{pricingtable.colorCurrency}};
                    font-family: {{pricingtable.useCustomFontCurrency ? pricingtable.customFontNameCurrency : pricingtable.fontFamilyCurrency}};
                    font-style: {{pricingtable.useCustomFontCurrency ? pricingtable.customFontStyleCurrency : pricingtable.fontStyleCurrency}};
                    font-weight: {{pricingtable.useCustomFontCurrency ? pricingtable.customFontWeightCurrency : pricingtable.fontWeightCurrency}};
                    font-size: {{pricingtable.fontSizeCurrency}}px;
                    vertical-align: {{pricingtable.alignCurrency}};
                }

                #{{pricingtable.tableId}} .bundle-pricing-table-content-item {
                    background: {{pricingtable.bgItem}};
                }

                #{{pricingtable.tableId}} .bundle-pricing-table-content-item span  {
                    color: {{pricingtable.colorItem}};
                    font-family: {{pricingtable.useCustomFontItem ? pricingtable.customFontNameItem : pricingtable.fontFamilyItem}};
                    font-style: {{pricingtable.useCustomFontItem ? pricingtable.customFontStyleItem : pricingtable.fontStyleItem}};
                    font-weight: {{pricingtable.useCustomFontItem ? pricingtable.customFontWeightItem : pricingtable.fontWeightItem}};
                    font-size: {{pricingtable.fontSizeItem}}px;
                }

                #{{pricingtable.tableId}} .bundle-pricing-table-action span {
                    color: {{pricingtable.colorButton}};
                    font-family: {{pricingtable.useCustomFontButton ? pricingtable.customFontNameButton : pricingtable.fontFamilyButton}};
                    font-style: {{pricingtable.useCustomFontButton ? pricingtable.customFontStyleButton : pricingtable.fontStyleButton}};
                    font-weight: {{pricingtable.useCustomFontButton ? pricingtable.customFontWeightButton : pricingtable.fontWeightButton}};
                    font-size: {{pricingtable.fontSizeButton}}px;
                    background: {{pricingtable.bgButton}};
                }

                #{{pricingtable.tableId}} .bundle-pricing-table-content-item i.check-icon-item {
                    color: {{pricingtable.colorIcon}}; 
                    font-size: {{pricingtable.fontSizeIcon}}px;
                }

            </component>

            <component :is="style">

                #{{settingsFromWeebly.settings.tableWrapperId}} .bundle-pricing-table {
                    width: {{100 / settingsFromWeebly.settings.amountDesktop}}%;
                }

                @media(max-width: 768px) {
                  #{{settingsFromWeebly.settings.tableWrapperId}} .bundle-pricing-table {
                        width: {{100 / settingsFromWeebly.settings.amountTablet}}%;
                    }  
                }

                @media(max-width: 576px) {
                  #{{settingsFromWeebly.settings.tableWrapperId}} .bundle-pricing-table {
                        width: {{100 / settingsFromWeebly.settings.amountPhone}}%;
                    }  
                }

                .bundle-pricing-table-1-wrap {
                    display: flex;
                    align-items: flex-start;
                    max-width: 985px;
                    margin: 0 auto;
                    flex-wrap: wrap;
                }
                .bundle-pricing-table-1 {
                    width: 100%;
                    margin: 0 auto; /* setting */
                    background: #fff;
                    border: 1px solid #ddd;
                    position: relative;
                }

                .bundle-pricing-table-1 .bundle-pricing-table-header {
                    text-align: center; /* setting */
                }
                .bundle-pricing-table-1 .bundle-pricing-table-header h4 {
                    margin: 0;
                    padding: 15px; /* setting */
                    background: #333;
                    color: #fff;
                }
                .bundle-pricing-table-1 .bundle-pricing-table-header h5 {
                    font-size: 45px; /* setting */
                    font-weight: 300; /* setting */
                    font-family: 'Helvetica Neue'; /* setting */
                    margin: 0;
                    padding: 30px 15px; /* setting */
                }
                .bundle-pricing-table-1 .bundle-pricing-table-header h5 span {
                    font-weight: 700; /* setting */
                    font-size: 14px; /* setting */
                    display: inline-block;
                    vertical-align: top;
                }
                .bundle-pricing-table-1 .bundle-pricing-table-content {
                    text-align: center; /* setting */
                    padding: 15px;
                }
                .bundle-pricing-table-1 .bundle-pricing-table-content-item {
                    padding: 15px;
                    margin-bottom: 10px;
                    background: rgba(0,0,0,0.02);
                    color: #777;
                }
                .bundle-pricing-table-1 .bundle-pricing-table-content-item span {
                    display: inline-block;
                    position: relative;
                    vertical-align: middle;
                }
                .bundle-pricing-table-1 .bundle-pricing-table-content-item:last-child {
                    margin-bottom: 0px;
                }
                .bundle-pricing-table-1 .bundle-pricing-table-content-item i.check-icon-item {
                    color: #999; /* setting */
                    margin-right: 7px;
                    font-size: 12px; /* setting */
                    color: #f65f47;
                    display: inline-block;
                    vertical-align: middle;
                }
                .bundle-pricing-table-1 .bundle-pricing-table-action {
                    text-align: center;
                    padding: 15px;
                }
                .bundle-pricing-table-1 .bundle-pricing-table-action a {
                    text-decoration: none!important;    
                }
                .bundle-pricing-table-1 .bundle-pricing-table-action span {
                    background: #f65f47;
                    display: inline-block;
                    color: #fff;
                    padding: 7px 15px;
                    border-radius: 3px;
                    display: block;
                }

            </component>

            <component :is="style" v-if="deviceStylesSetttings.tabletStyles">
                #{{settingsFromWeebly.settings.tableWrapperId}} .bundle-pricing-table {
                    width: {{100 / settingsFromWeebly.settings.amountTablet}}%;
                }
            </component>

            <component :is="style" v-if="deviceStylesSetttings.mobileStyles">
                #{{settingsFromWeebly.settings.tableWrapperId}} .bundle-pricing-table {
                    width: {{100 / settingsFromWeebly.settings.amountPhone}}%;
                }
            </component>
            

        </div>

    </div>

</template>

<script>
import PricingtableElement from './elementSettings/pricingtableelement/PricingtableElement'
import draggable from 'vuedraggable'

export default {

    name: 'Pricingtables',

    data () {

        return {
            style: 'style'
        }
    },

    components: {
        PricingtableElement,
        draggable
    },

    methods: {
        
        switchDevice(event) {

            // remove active class from possible elements
            const icons = document.querySelectorAll('.device-selector--large i');
            icons.forEach(icon => {
                console.log(icon)
                icon.classList.remove('active')
            })
            
            // add active class to current
            event.target.classList.add('active');

            console.log(event.target.dataset.device)

            // set active settings to true
            this[event.target.dataset.device] = true

            if(event.target.dataset.device === 'tabletSettings') {
                this.$store.state.previewBoxWidth = '768px'
                this.$store.state.deviceStyles.mobileStyles = false
                this.$store.state.deviceStyles.tabletStyles = true
                this.$store.state.deviceStyles.desktopStyles = false
            } else if (event.target.dataset.device === 'mobileSettings') {
                this.$store.state.previewBoxWidth = '576px'
                this.$store.state.deviceStyles.tabletStyles = false
                this.$store.state.deviceStyles.mobileStyles = true
                this.$store.state.deviceStyles.desktopStyles = false
            } else {
                this.$store.state.previewBoxWidth = '100%'
                this.$store.state.deviceStyles.tabletStyles = false
                this.$store.state.deviceStyles.mobileStyles = false
                this.$store.state.deviceStyles.desktopStyles = true
            }

        },

        addToChildArray() {

            console.log(this.$store.state.weeblySettings.settings.tables);

            // this.removeActiveFromBlock()

            this.$store.state.weeblySettings.settings.tables.push(
                {
                    tableId: 'bundle-pricingtable-'+Math.random().toString(36).substr(2, 16),
                    planName: 'Plan Name',
                    price: '700',
                    currency: '$',
                    link: 'https://www.appjustable.com',
                    linkText: 'Buy Now',
                    target: '_blank',

                    useCustomFontPlan: false,
                    customFontNamePlan: "'Helvetica Neue', sans-serif",
                    customFontWeightPlan: "400",
                    customFontStylePlan: 'normal',

                    fontFamilyPlan: 'Roboto',
                    fontWeightPlan: '400',
                    fontStylePlan: 'normal',
                    fontGoogleLoadPlan: 'Roboto:400',
                    fontSizePlan: 17,
                    colorPlan: '#fff',
                    bgPlan: '#333',


                    useCustomFontPrice: false,
                    customFontNamePrice: "'Helvetica Neue', sans-serif",
                    customFontWeightPrice: "100",
                    customFontStylePrice: 'normal',

                    fontFamilyPrice: 'Roboto',
                    fontWeightPrice: '100',
                    fontStylePrice: 'normal',
                    fontGoogleLoadPrice: 'Roboto:100',
                    fontSizePrice: 30,
                    colorPrice: '#333',

                    useCustomFontItem: false,
                    customFontNameItem: "'Helvetica Neue', sans-serif",
                    customFontWeightItem: "400",
                    customFontStyleItem: 'normal',

                    fontFamilyItem: 'Roboto',
                    fontWeightItem: '400',
                    fontStyleItem: 'normal',
                    fontGoogleLoadItem: 'Roboto:400',
                    fontSizeItem: 14,
                    colorItem: '#777',
                    bgItem: '#fafafa',

                    colorIcon: '#f65f47',
                    fontSizeIcon: 12,
                    hideIcon: true,

                    useCustomFontCurrency: false,
                    customFontNameCurrency: "'Helvetica Neue', sans-serif",
                    customFontWeightCurrency: "400",
                    customFontStyleCurrency: 'normal',

                    fontFamilyCurrency: 'Roboto',
                    fontWeightCurrency: '400',
                    fontStyleCurrency: 'normal',
                    fontGoogleLoadCurrency: 'Roboto:400',
                    fontSizeCurrency: 14,
                    colorCurrency: '#777',
                    alignCurrency: 'super',

                    useCustomFontButton: false,
                    customFontNameButton: "'Helvetica Neue', sans-serif",
                    customFontWeightButton: "400",
                    customFontStyleButton: 'normal',

                    fontFamilyButton: 'Roboto',
                    fontWeightButton: '400',
                    fontStyleButton: 'normal',
                    fontGoogleLoadButton: 'Roboto:400',
                    fontSizeButton: 14,
                    colorButton: '#fff',
                    bgButton: '#f65f47',

                    items: [
                        {
                            name: 'item 1 included',
                        },
                        {
                            name: 'item 2 included',
                        },
                        {
                            name: 'item 3 included',
                        }
                    ]
                }
            )

        },

    },

    computed: {

        // device Styles
        deviceStylesSetttings() {
            return this.$store.state.deviceStyles
        },

        // access settings from Weebly to display all correct
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        globalSettings() {
            return this.$store.state
        },

        // preview width box
        previewBoxWidth() {
            return this.$store.state.previewBoxWidth
        },
        // get array of titles
        slidesArray: {
            get() {
                return this.$store.state.weeblySettings.settings.tables
            },
            set(value) {
                console.log(value)
                // this.$store.commit('updateList', value)
                return this.$store.state.weeblySettings.settings.tables = value
            }
        }

    },
    
    mounted() {
        console.log('from tables', this.$store.state.weeblySettings)
        // show save button
        this.$store.state.showSaveBtn = true

        // show settings
        this.$store.state.showSettingsBar = true

        // add class active to preview window for later use in getting the innerHTML - done via Topbar element
        document.querySelector('.preview-box').classList.add('active')


    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import '../../less/colors.less';
.preview-box .only-weebly-editor {
    display: block;
}
.bundle-pricing-table-wrap {
    max-width: 985px;
    margin: 0 auto;
}
.addChildBlock-btn {
    font-weight: 700;
    position: absolute;
    right: -75px;
    top: -9px;
    width: 50px;
    height: 50px;
    line-height: 50px;
    border-radius: 50%;
    padding: 0;
    margin: 0;
    font-size: 20px;
    -webkit-box-shadow: 0 5px 17px rgba(76, 193, 149, 0.6);
    box-shadow: 0 5px 17px rgba(76, 193, 149, 0.6);
    -webkit-transition: all 0.3s ease-out;
    transition: all 0.3s ease-out;
    background: #4CC195;
    border: 0;
}
.addChildBlock-btn:hover {
    -webkit-transform: translateY(-4px);
    transform: translateY(-4px);
    -webkit-box-shadow: 0 7px 24px rgba(76, 193, 149, 0.7);
    box-shadow: 0 7px 24px rgba(76, 193, 149, 0.7);
    background: rgba(76, 193, 149, 0.9);
}
</style>



// WEBPACK FOOTER //
// src/components/elements/Pricingtables.vue